/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{getPlacementOperator as t}from"../CIMOperators.js";class e{static getPlacement(e,r,n,s,c){const o=t(n);if(!o)return null;-1===r&&e.invertY();return o.execute(e,n,s,c)}}export{e as CIMMarkerPlacementHelper};
